<template>
    <div>
        <!-- <section class="inner_banner">

        </section> -->

        <section class="faq">
            <div class="container">
                <h2>Faq's</h2>
                <article class="row justify-content-center">
                    <aside class="col-md-8">
                        <div class="panel-group" id="accordion" role="tablist" aria-multiselectable="true">
                            <div class="panel panel-default">
                                <div class="panel-heading" role="tab" id="headingOne">
                                    <h4 class="panel-title">
                                        <a role="button" data-toggle="collapse" data-parent="#accordion" href="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                            What coins are available on Stable Switch?
                                        </a>
                                    </h4>
                                </div>
                                <div id="collapseOne" class="panel-collapse collapse show" role="tabpanel" aria-labelledby="headingOne" data-parent="#accordion">
                                    <div class="panel-body">
                                        <p>At the moment, Stable Switch allows users to make trades with USDT and USDC coins. However, we will be adding new coins to the platform in the future, to ensure that we meet the demand of our users. </p>
                                    </div>
                                </div>
                            </div>

                            <div class="panel panel-default">
                                <div class="panel-heading" role="tab" id="headingTwo">
                                    <h4 class="panel-title">
                                        <a class="collapsed" role="button" data-toggle="collapse" data-parent="#accordion" href="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                                            Is there a withdrawal fee for using the platform?
                                        </a>
                                    </h4>
                                </div>
                                <div id="collapseTwo" class="panel-collapse collapse" role="tabpanel" aria-labelledby="headingTwo" data-parent="#accordion">
                                    <div class="panel-body">
                                        <p>No. All of our trades and fees are calculated based on the volume of the Stable Switch Liquidity Pools. If you deposit a coin in a stock which is currently offering a negative fee, then we will pay you to switch on the site. Consider it a gift from us. </p>
                                    </div>
                                </div>
                            </div>

                            <div class="panel panel-default">
                                <div class="panel-heading" role="tab" id="headingThree">
                                    <h4 class="panel-title">
                                        <a class="collapsed" role="button" data-toggle="collapse" data-parent="#accordion" href="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                                            What is the fee for using Stable Switch?
                                        </a>
                                    </h4>
                                </div>
                                <div id="collapseThree" class="panel-collapse collapse" role="tabpanel" aria-labelledby="headingThree" data-parent="#accordion">
                                    <div class="panel-body">
                                        <p>All of the fees that you will pay during your use of Stable Switch are calculated using our Dynamic system. This means that your fee is determined by the volumes of the liquidity pools. For more information, please visit the fee section of the homepage to view the live fee for each trading pair. </p>
                                    </div>
                                </div>
                            </div>
                            <div class="panel panel-default">
                                <div class="panel-heading" role="tab" id="headingFour">
                                    <h4 class="panel-title">
                                        <a class="collapsed" role="button" data-toggle="collapse" data-parent="#accordion" href="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
                                            What is the Stable Switch Liquidity Pool Lending Programme?
                                        </a>
                                    </h4>
                                </div>
                                <div id="collapseFour" class="panel-collapse collapse" role="tabpanel" aria-labelledby="headingFour" data-parent="#accordion">
                                    <div class="panel-body">
                                        <p>The Stable Switch Liquidity Pool Lending Programme is a system whereby you can earn a percentage of the fees which are generated here on the platform. By depositing funds into the Liquidity Pool, you can generate earnings. Please visit the lending page on the website for further information. </p>
                                    </div>
                                </div>
                            </div>
                            <div class="panel panel-default">
                                <div class="panel-heading" role="tab" id="headingFive">
                                    <h4 class="panel-title">
                                        <a class="collapsed" role="button" data-toggle="collapse" data-parent="#accordion" href="#collapseFive" aria-expanded="false" aria-controls="collapseFive">
                                            Why do I need to select which coins I receive when lending to the Liquidity Pools?
                                        </a>
                                    </h4>
                                </div>
                                <div id="collapseFive" class="panel-collapse collapse" role="tabpanel" aria-labelledby="headingFive" data-parent="#accordion">
                                    <div class="panel-body">
                                        <p>Anyone who becomes a lender on the website can receive a higher percentage of fees based on which Stable Coins they choose to receive during the withdrawal of capital. You can choose to either work with one coin specifically, or you can get the best results by allowing yourself to work with a selection of Stable Coins traded here on the Stable Switch platform. </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </aside>
                </article>
            </div>
        </section>
    </div>
</template>

<script>
export default {
    name: 'Faq'
}
</script>

<style scoped>

</style>
